import React from 'react';
import cx from 'classnames';

import './Skeleton.sass';

export default function Skeleton({ variant = 'text', className, width, height, children }) {
  return (
    <span
      className={cx(
        "skeleton",
        `skeleton--${variant}`,
        children && "skeleton--children",
        children && !width && "skeleton--hasChildrenNoHeight",
        children && !height && "skeleton--hasChildrenNoWidth",
        className
      )}
      style={{ width: width, height: height }}
    >
      {children && <span>{children}</span>}
    </span>
  );
}



// WEBPACK FOOTER //
// ./components/skeleton/Skeleton.js